import SetTelegram from '@/modules/UserSettings/components/SetTelegram.vue';

import store from '@/store';

import { modalsController } from './modals';

export const user = {
  get data() {
    return store.getters['auth/userData'];
  },
  get organization() {
    const [primaryOrganization] = this.data.organizations || [];
    return primaryOrganization;
  },
  get orgRole() {
    return this.organization?.role;
  },
  get isAuthenticated() {
    return store.getters['auth/isAuthenticated'];
  },
  get isOrganization() {
    return store.getters['auth/isOrganization'];
  },
  get isOperator() {
    return store.getters['auth/isOperator'];
  },
  get isDepartment() {
    return store.getters['auth/isDepartment'];
  },
  get isTeacher() {
    return store.getters['auth/isTeacher'];
  },
  get isStudent() {
    return store.getters['auth/isStudent'];
  },
  get isListener() {
    return store.getters['auth/isListener'];
  },
  get isMentor() {
    return this.orgRole === 8;
  },
  get secondStepRequired() {
    return store.getters['auth/secondStepRequired'];
  },
  get studentMode() {
    return this.isTeacher && store.getters['auth/studentMode'];
  },

  openSignUpTelegram() {
    modalsController.show('generic-controller', {
      component: SetTelegram,
    });
  },
  /**
   * Обновляет пользователя
   */
  syncUser() {
    return store.dispatch('auth/FETCH_USER');
  },
};

export default {
  install(Vue) {
    Vue.user = user;
    Vue.prototype.$user = user;
  },
};
